/** Apply the selected border and its coordinated action accent. */
import { watch } from "vue";
import { selectionAppearance } from "@/utils/selectionAppearance";
import { BorderColors, useSettingsStore } from "@/stores/settings.store";

export function useSelectionBorder() {
  const settings = useSettingsStore();
  watch(
    () => [
      settings.selectionBorderStyle,
      settings.borderColor,
      settings.borderGradient,
    ],
    () => {
      if (typeof document === "undefined") return;
      const appearance = selectionAppearance(
        settings.selectionBorderStyle,
        BorderColors[settings.borderColor].primary,
        settings.borderGradient,
      );
      const tokens = {
        "--selection-border": appearance.border,
        "--accent-color": appearance.accent,
        "--accent-color-2": appearance.accent,
        "--accent-color-rgb": appearance.rgb,
        "--accent-color-2-rgb": appearance.rgb,
        "--accent-foreground": appearance.foreground,
      };
      for (const [name, value] of Object.entries(tokens)) {
        document.documentElement.style.setProperty(name, value);
      }
    },
    { immediate: true },
  );
}
